import { useTranslation } from "react-i18next";
import { HStack, VStack } from "@chakra-ui/react";

// import { CreateAsset } from 'graphql/queries/types/CreateAsset';
// import { UpdateAsset } from 'graphql/queries/types/UpdateAsset';

import {
  AssetInput,
} from "graphql/queries/generated/queries";

import { FieldGroup, FormInputHook } from "components/ui";
import { BaseSyntheticEvent } from "react";

import ASSET_CONSTANTS from "constants/asset";

import {
  UseFormRegister,
  UseFormGetValues,
  UseFormSetError,
  UseFormSetValue,
} from "react-hook-form";

interface SettingNewCategoryFormProps {
  onSubmit: (e?: BaseSyntheticEvent<object, any, any>) => Promise<void>;
  register: UseFormRegister<AssetInput>;
  getValues: UseFormGetValues<AssetInput>;
  watch: any; // UseFormWatch<AssetInput>,
  setValue: UseFormSetValue<AssetInput>;
  setError: UseFormSetError<AssetInput>;
  category: string;
  children?: React.ReactNode;
}


const SettingNewCategoryForm = ({
  // eslint-disable-next-line react/prop-types
  onSubmit,
  // handleChange,
  // handleRadioButtons,
  // values,
  register,
  setValue,
  setError,
  getValues,
  watch,
  category,
  children,
}: SettingNewCategoryFormProps) => {
  const { t } = useTranslation();
  const { title } = getValues();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call
  const hasBarriers = watch("hasBarriers");

  return (
    <>
      {/* <Box p={6} maxW="6xl">
        <Stack spacing="4" divider={<StackDivider />}> */}
          <FieldGroup title={t("Barriers and handling")} subtitle={t("Setting - Barriers and handling - Lorem ipsum dolor sit amet")} py={8}>
            <HStack>
              <FormInputHook label="Barriers / Protections" type="checkbox" name="hasBarriers" />

              {hasBarriers && <FormInputHook label="Barriers/protection notes" name="barriersDetails" />}
            </HStack>


            <FormInputHook label="Handling requirements" type="textarea" name="handlingRequirements" />

          </FieldGroup>



          <FieldGroup title={t("Injury risk")} subtitle={t("Setting - Injury risk - Lorem ipsum dolor sit amet")} py={8}>
            <VStack width="full" align="left">
              <HStack alignItems="flex-end">
                <FormInputHook
                  label="Injury risk"
                  options={ASSET_CONSTANTS.INJURY_RISK}
                  name="injuryRisk"
                />
                <FormInputHook label="Description" type="textarea" name="injuryRiskDescription" />
              </HStack>
            </VStack>
          </FieldGroup>


          <FieldGroup title={t("Setting details")} subtitle={t("Setting - Setting details - Lorem ipsum dolor sit amet")} py={8}>
            <VStack width="full" align="left">
              <HStack alignItems="flex-end">
                <FormInputHook label="Moulding support base" type="textarea" name="mouldingSupportBase" />
              </HStack>

              <HStack alignItems="flex-end">
                <FormInputHook label="Hardware tools / installation" type="textarea" name="hardwareToolsInstallation" />
              </HStack>

              <HStack alignItems="flex-end">
                <FormInputHook label="Conservation" type="textarea" name="conservation" />
              </HStack>

              <HStack alignItems="flex-end">
                <FormInputHook label="Lender requests" type="textarea" name="lenderRequests" />
              </HStack>
            </VStack>
          </FieldGroup>




          <FieldGroup title={t("Setting notes")} subtitle={t("Setting - Setting notes - Lorem ipsum dolor sit amet")} py={8}>
            <VStack width="full" align="left">
              <HStack>
                <FormInputHook
                  label="Setting notes"
                  name="settingNotes"
                  type="textarea"
                />
              </HStack>
            </VStack>
          </FieldGroup>



          {/* <Button
            isLoading={createAssetLoading || updateAssetLoading}
            loadingText="Loading"
            type="submit"
          >
            {t("Save")}
          </Button>
          {children} */}
        {/* </Stack>
      </Box> */}
      {/* <ButtonGroup pb={6} pl={6} display="block" textAlign="left" variant="outline">
        <Button
            isLoading={createAssetLoading || updateAssetLoading}
            loadingText="Loading"
            type="submit"
            variant="primary"
          >
            {t("Update")}
        </Button>
        {children}
      </ButtonGroup> */}
    </>
  );
};

export default SettingNewCategoryForm;
